var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 179,
    height: 57,
    viewBox: "0 0 179 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_923_6193)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.7471 30.9673C79.7471 26.0425 82.8287 23.1121 86.6447 23.1121C88.5311 23.1121 90.0359 24.0121 90.9791 25.0201L89.5535 26.7409C88.7831 25.9705 87.8759 25.4305 86.7023 25.4305C84.2543 25.4305 82.4975 27.5041 82.4975 30.8809C82.4975 34.2577 84.1175 36.3961 86.6375 36.3961C87.9695 36.3961 89.0063 35.7769 89.8487 34.8481L91.2743 36.5257C90.0575 37.9441 88.4807 38.7145 86.5367 38.7145C82.7495 38.7145 79.7543 35.9425 79.7543 30.9601L79.7471 30.9673Z",
    fill: "#F7F8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.8016 23.3857H96.8184L99.4824 30.7441C99.8136 31.7017 100.116 32.7169 100.447 33.6961H100.541C100.872 32.7097 101.16 31.6945 101.491 30.7441L104.098 23.3857H107.114V38.4409H104.666V31.5577C104.666 30.1681 104.875 28.1665 105.005 26.7697H104.911L103.694 30.2689L101.218 37.0297H99.6336L97.1496 30.2689L95.9544 26.7697H95.8608C95.9904 28.1665 96.1992 30.1681 96.1992 31.5577V38.4409H93.7944V23.3857H93.8016Z",
    fill: "#F7F8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.922 36.5113L111.478 34.6825C112.558 35.7121 113.998 36.3961 115.402 36.3961C117.094 36.3961 118.022 35.6257 118.022 34.4521C118.022 33.2137 117.05 32.8177 115.682 32.2345L113.623 31.3417C112.14 30.7225 110.578 29.5489 110.578 27.3529C110.578 24.9553 112.694 23.1121 115.632 23.1121C117.389 23.1121 119.095 23.8393 120.269 25.0345L118.901 26.7265C117.943 25.9129 116.921 25.4305 115.632 25.4305C114.206 25.4305 113.278 26.1001 113.278 27.2017C113.278 28.3825 114.422 28.8217 115.675 29.3329L117.706 30.1825C119.498 30.9313 120.751 32.0617 120.751 34.2433C120.751 36.6841 118.728 38.7145 115.344 38.7145C113.306 38.7145 111.348 37.9153 109.922 36.5113Z",
    fill: "#F7F8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6263 26.6615L8.40234 28.6703L19.3607 27.7559L29.5847 28.6703L20.0879 26.6615L19.3607 12.0527L18.6335 26.6615H18.6263Z",
    fill: "#EC722E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3536 56.4264L37.8 29.7648L19.3536 53.5032L3.6504 31.0464L10.044 34.5168L15.7032 46.9368L11.6856 34.5168H27.0216L23.5512 44.7408L28.8504 34.3296L34.1496 31.0392L28.8504 32.868L19.5408 2.736L27.0288 32.868H12.0528L18.9936 2.556L10.4112 32.868L2.7432 28.6704L19.3536 1.8288L29.9448 16.9848L19.3536 0L0 29.0376L19.3536 56.4264Z",
    fill: "#F7F8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.322 37.6919H164.261",
    stroke: "#EC722E",
    strokeWidth: 2.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.072 24.6384H157.421L162.806 37.0656",
    stroke: "#EC722E",
    strokeWidth: 2.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.571 24.4368H147.686",
    stroke: "#EC722E",
    strokeWidth: 2.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.79 37.6919H154.728",
    stroke: "#EC722E",
    strokeWidth: 2.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.421 24.8472L152.654 37.2744",
    stroke: "#EC722E",
    strokeWidth: 2.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.728 32.9255H160.733",
    stroke: "#EC722E",
    strokeWidth: 2.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.78 37.6919H147.895",
    stroke: "#EC722E",
    strokeWidth: 2.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.129 24.4368V37.4904",
    stroke: "#EC722E",
    strokeWidth: 2.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.451 24.4656H124.898M124.898 24.4656C124.898 24.4656 129.593 24.3936 130.284 24.4656C130.975 24.5304 134.014 26.9208 134.014 28.5768V33.3432C134.014 36.2376 130.702 37.7208 130.702 37.7208H124.898M124.898 24.4656V37.7208M123.451 37.7208H124.898",
    stroke: "#EC722E",
    strokeWidth: 2.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.9997 9.16553L45.7197 28.2455L62.2797 46.6055",
    stroke: "#F7F8FF",
    strokeWidth: 2.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.64 9.16553L178.92 28.2455L162.36 46.6055",
    stroke: "#F7F8FF",
    strokeWidth: 2.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.1599 12.0457L65.8799 43.0057",
    stroke: "#F7F8FF",
    strokeWidth: 2.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_923_6193"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 178.92,
    height: 56.4264,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.ffa09c99517425705de7c787be55a2e1.svg";
export { ForwardRef as ReactComponent };